import {
  Component,
  EventEmitter,
  ElementRef,
  Output
} from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaService } from '../../../../ui-components/src/services/okta.service';

@Component({
  selector: 'okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.scss'],
  standalone: true
})
export class OktaLoginComponent {
  @Output() isIntersecting = new EventEmitter<boolean>();
  private observer: IntersectionObserver | null = null;

  constructor(
    public oktaAuth: OktaAuthModule,
    public oktaService: OktaService,
    private _el: ElementRef,
  ) {}

  async ngOnInit() {
    this._watchElementForEntry();
  }

  private _watchElementForEntry(): void {
    const options: IntersectionObserverInit = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const callback = (entries: IntersectionObserverEntry[]): void => {
      entries.forEach(entry => {
        this.isIntersecting.emit(entry.isIntersecting);

        if (entry.isIntersecting) {
          this.loginWithRedirect();
          this.observer?.unobserve(entry.target);
        }
      });
    };

    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(this._el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  loginWithRedirect() {
    if (this.oktaService.getIsAuthenticated()) {
      this.oktaService.loginOkta(() => {});
    }
  }
}
